import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { routes } from '@/router'

import { DevlopCreate } from './devlop-create.component'
import { DevlopDetailContainer } from './devlop-detail/devlop-detail.container'
import { DevlopHome } from './devlop-home.component'

export const DevlopContainer = () => {
  return (
    <Switch>
      <Route exact path={routes.devlop.home} component={DevlopHome} />
      <Route exact path={routes.devlop.create} component={DevlopCreate} />
      <Route exact path={routes.devlop.detail(':selfId')} component={DevlopDetailContainer} />
      <Redirect to={routes.devlop.home} />
    </Switch>
  )
}
